// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const TogetherPauseButton = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<circle cx={20} cy={20} r={19.5} stroke="#383838" />
		<rect x={14.5} y={12.5} width={3} height={15} rx={1.5} stroke="#383838" />
		<rect x={22.5} y={12.5} width={3} height={15} rx={1.5} stroke="#383838" />
	</svg>
);
export default TogetherPauseButton;
